import { Box, Text } from '@doist/marketist';
import css from './alert.module.css';
type AlertProps = {
  children?: React.ReactNode;
  includeTextWrapper?: boolean;
};
export function Alert({
  children,
  includeTextWrapper = true
}: AlertProps) {
  return <Box className={css.alert} data-sentry-element="Box" data-sentry-component="Alert" data-sentry-source-file="alert.tsx">
            {includeTextWrapper ? <Text size="minor-base">{children}</Text> : children}
        </Box>;
}